import { ReactNode, useEffect } from "react";
import TagManager from "react-gtm-module";

const GTM_CONTAINER = "GTM-NZ9VH65";

type GtmProviderProps = {
  children: ReactNode;
};

const GtmProvider = ({ children }: GtmProviderProps) => {
  useEffect(() => {
    TagManager.initialize({ gtmId: GTM_CONTAINER });
  }, []);

  return <>{children}</>;
};

export default GtmProvider;
